var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncidentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81462 6.02307L2.94335 15.8247C2.8223 16.0343 2.75825 16.272 2.75757 16.5141C2.7569 16.7561 2.81962 16.9942 2.93949 17.2045C3.05937 17.4148 3.23222 17.5901 3.44086 17.7128C3.64949 17.8356 3.88664 17.9016 4.1287 17.9042H15.8712C16.1133 17.9016 16.3504 17.8356 16.5591 17.7128C16.7677 17.5901 16.9406 17.4148 17.0604 17.2045C17.1803 16.9942 17.243 16.7561 17.2424 16.5141C17.2417 16.272 17.1776 16.0343 17.0566 15.8247L11.1853 6.02307C11.0617 5.81935 10.8877 5.65091 10.6801 5.53402C10.4725 5.41712 10.2382 5.35571 9.99996 5.35571C9.76169 5.35571 9.52744 5.41712 9.31982 5.53402C9.11219 5.65091 8.93819 5.81935 8.81462 6.02307V6.02307Z",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.46826V12.3972",
    stroke: "#33894E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.0176H10.0071",
    stroke: "#33894E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentsIcon);
export default __webpack_public_path__ + "static/media/IncidentsIcon.aa7ef34ad25cbb49dba458d0eef9bb5e.svg";
export { ForwardRef as ReactComponent };